import { connect } from 'react-redux';
import SwitchToAutoPaySuccess from './SwitchToAutoPaySuccess';

function mapStateToProps({ config }) {
  return {
    consumerHost: config.consumerHost,
  };
}

export default connect(mapStateToProps)(SwitchToAutoPaySuccess);
